import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import {
  type APIResponse,
  type MatterTaskPlan,
  type MatterTaskPlanTask,
} from "@/lib/types";

export type MatterTaskPlanWithTasks = MatterTaskPlan & {
  taskCount: number;
  tasks: MatterTaskPlanTask[];
};

export type RetrieveMatterTaskPlansParams = {
  incidentTypeIds?: string[];
  statusIds?: string[];
  triggerTypes?: string[];
};

export const retrieveMatterTaskPlans = async (
  filters: RetrieveMatterTaskPlansParams = {},
) => {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<MatterTaskPlanWithTasks[]>>(
      `${baseFastApiMatterRoute}/task-plans`,
      {
        params: filters,
        paramsSerializer: { indexes: null },
      },
    )
    .then((res) => res.data);
};

export const createMatterTaskPlanV1 = async (
  data: Pick<MatterTaskPlan, "title" | "incidentTypeIds"> &
    Partial<MatterTaskPlan>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTaskPlan>
    >(`${baseFastApiMatterRoute}/task-plans`, data)
    .then((res) => res.data);
};

export const updateMatterTaskPlanV1 = async (
  data: Pick<MatterTaskPlan, "id" | "dateModified">,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterTaskPlan>
    >(`${baseFastApiMatterRoute}/task-plans`, data)
    .then((res) => res.data);
};

export const deleteMatterTaskPlanV1 = async (
  data: Pick<MatterTaskPlan, "id">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterTaskPlan>
    >(`${baseFastApiMatterRoute}/task-plans/${id}`)
    .then((res) => res.data);
};

// Matter Task Plan Task API Requests
export const createMatterTaskPlanTaskV1 = async (
  data: Pick<MatterTaskPlanTask, "taskPlanId" | "title"> &
    Partial<MatterTaskPlanTask>,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTaskPlanTask>
    >(`${baseFastApiMatterRoute}/task-plans/tasks`, data)
    .then((res) => res.data);
};

export const updateMatterTaskPlanTaskV1 = async (
  data: Pick<MatterTaskPlanTask, "id" | "dateModified"> &
    Partial<MatterTaskPlanTask>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterTaskPlanTask>
    >(`${baseFastApiMatterRoute}/task-plans/tasks`, data)
    .then((res) => res.data);
};

export const deleteMatterTaskPlanTaskV1 = async (
  data: Pick<MatterTaskPlanTask, "id" | "taskPlanId">,
) => {
  const { id, taskPlanId } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterTaskPlanTask>
    >(`${baseFastApiMatterRoute}/task-plans/${taskPlanId}/tasks/${id}`)
    .then((res) => res.data);
};
